import { useMantineTheme } from "@mantine/core";

export const CashStackIcon = () => {
  const theme = useMantineTheme();

  return (
    <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="20.5" cy="20" r="20" fill={theme.other.primary[10]} />
      <mask
        id="mask0_15918_51277"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="8"
        y="8"
        width="25"
        height="24"
      >
        <rect x="8.5" y="8" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_15918_51277)">
        <path
          d="M22.5 21C21.6667 21 20.9583 20.7083 20.375 20.125C19.7917 19.5417 19.5 18.8333 19.5 18C19.5 17.1667 19.7917 16.4583 20.375 15.875C20.9583 15.2917 21.6667 15 22.5 15C23.3333 15 24.0417 15.2917 24.625 15.875C25.2083 16.4583 25.5 17.1667 25.5 18C25.5 18.8333 25.2083 19.5417 24.625 20.125C24.0417 20.7083 23.3333 21 22.5 21ZM15.5 24C14.95 24 14.4793 23.804 14.088 23.412C13.696 23.0207 13.5 22.55 13.5 22V14C13.5 13.45 13.696 12.9793 14.088 12.588C14.4793 12.196 14.95 12 15.5 12H29.5C30.05 12 30.521 12.196 30.913 12.588C31.3043 12.9793 31.5 13.45 31.5 14V22C31.5 22.55 31.3043 23.0207 30.913 23.412C30.521 23.804 30.05 24 29.5 24H15.5ZM17.5 22H27.5C27.5 21.45 27.6957 20.979 28.087 20.587C28.479 20.1957 28.95 20 29.5 20V16C28.95 16 28.479 15.804 28.087 15.412C27.6957 15.0207 27.5 14.55 27.5 14H17.5C17.5 14.55 17.304 15.0207 16.912 15.412C16.5207 15.804 16.05 16 15.5 16V20C16.05 20 16.5207 20.1957 16.912 20.587C17.304 20.979 17.5 21.45 17.5 22ZM28.5 28H11.5C10.95 28 10.4793 27.8043 10.088 27.413C9.696 27.021 9.5 26.55 9.5 26V15H11.5V26H28.5V28Z"
          fill="#501E82"
        />
      </g>
    </svg>
  );
};
